import { Theme } from '../../store/types/theme';

export const themes: Theme[] = [
    {
        id: 'default-beige-green',
        title: 'Beige Green',
        color: {
            main: '#F4E3C1',
            point: '#4A7658',
            sub: '#F0BE81',
            pointOptions: ['#F07F7F', '#8B72CB', '#6372BB', '#5892D0', '#4A7658', '#FFD438', '#F89B00', '#E15B5B'],
        },
        text: 'Great things\ntake time.',
    },
    {
        id: 'default-gray-purple',
        title: 'Gray Purple',
        color: {
            main: '#DCE0E3',
            point: '#9079C9',
            sub: '#D7D5E0',
            pointOptions: ['#F7ABC5', '#9079C9', '#7A97F0', '#88B8DD', '#6B9E87', '#fED367', '#fBAD65', '#f55C5C'],
        },
        text: 'Becoming a better\nversion of me.',
    },
    {
        id: 'default-black-green',
        title: 'Black Green',
        color: {
            main: '#202123',
            point: '#4C6A60',
            sub: '#CEE5DD',
            pointOptions: ['#FFA3B9', '#7457BC', '#0E64AF', '#4BACB9', '#4C6A60', '#FFB700', '#EB7A1E', '#C40808'],
        },
        text: 'For my better\ntomorrow.',
    },
    {
        id: 'default-sky-blue',
        title: 'Sky Blue',
        color: {
            main: '#C8D9EB',
            point: '#76A3DE',
            sub: '#FFF0B9',
            pointOptions: ['#4A668B', '#597aa6', '#7A96BB', '#789AC6', '#779FD2', '#76A3DE', '#87AFE2', '#A9C6EA'],
        },
        text: 'Dive deep into dreams,\nlet your spirit soar.',
    },
    {
        id: 'default-lovely-pink',
        title: 'Lovely Pink',
        color: {
            main: '#FFD6D6',
            point: '#F48FB1',
            sub: '#FDF4AC',
            pointOptions: ['#B76B85', '#C8899E', '#D78BA5', '#E58DAB', '#F48FB1', '#F59DBB', '#F7ABC4', '#F8B9CE'],
        },
        text: 'Every sunset brings\na promise of a new dawn.',
    },
    // === Anime Themes (background images fetched on demand) ===
    // bgQuery is a canonical Wikipedia article title; imageSearch.ts also has
    // an explicit ANIME_WIKI_TITLES map as a fallback.
    {
        id: 'anime-dragonball-z',
        title: 'Dragonball Z',
        color: {
            main: '#0a1428',
            point: '#00B4D8',
            sub: '#0077B6',
            pointOptions: ['#00B4D8', '#0077B6', '#90E0EF', '#CAF0F8', '#03045E', '#0096C7', '#48CAE4', '#023E8A'],
        },
        text: 'Go Super\nSaiyan Blue!',
        bgQuery: 'Super Saiyan Blue Goku',
    },
    {
        id: 'anime-buu',
        title: 'Majin Buu',
        color: {
            main: '#2a0a1f',
            point: '#FF85C0',
            sub: '#C56DB7',
            pointOptions: ['#FF85C0', '#FFC1E0', '#9B5DE5', '#C56DB7', '#F15BB5', '#FF6BB5', '#B83B8E', '#7D3C98'],
        },
        text: 'Sweet and\nstrong!',
        bgQuery: 'Majin Buu',
    },
    {
        id: 'anime-conan',
        title: 'Detective Conan',
        color: {
            main: '#0f1b2d',
            point: '#3B82F6',
            sub: '#93C5FD',
            pointOptions: ['#3B82F6', '#93C5FD', '#EF4444', '#F59E0B', '#10B981', '#8B5CF6', '#EC4899', '#06B6D4'],
        },
        text: 'One truth\nprevails.',
        bgQuery: 'Case Closed',
    },
    {
        id: 'anime-beyblade-x',
        title: 'Beyblade X',
        color: {
            main: '#06141f',
            point: '#06B6D4',
            sub: '#22D3EE',
            pointOptions: ['#06B6D4', '#22D3EE', '#3B82F6', '#A855F7', '#F59E0B', '#EF4444', '#10B981', '#E11D48'],
        },
        text: 'Let it rip!',
        bgQuery: 'Beyblade',
    },
    {
        id: 'anime-tsubasa',
        title: 'Captain Tsubasa',
        color: {
            main: '#0a1f0e',
            point: '#22C55E',
            sub: '#86EFAC',
            pointOptions: ['#22C55E', '#86EFAC', '#FACC15', '#3B82F6', '#EF4444', '#FFFFFF', '#10B981', '#65A30D'],
        },
        text: 'Dream\non the pitch.',
        bgQuery: 'Captain Tsubasa',
    },
    {
        id: 'anime-kuroko',
        title: 'Kuroko Basketball',
        color: {
            main: '#0c1430',
            point: '#60A5FA',
            sub: '#F472B6',
            pointOptions: ['#60A5FA', '#F472B6', '#F59E0B', '#10B981', '#EF4444', '#A855F7', '#06B6D4', '#FBBF24'],
        },
        text: 'Pass first,\nwin together.',
        bgQuery: "Kuroko's Basketball",
    },
    {
        id: 'anime-slam-dunk',
        title: 'Slam Dunk',
        color: {
            main: '#1a0a0a',
            point: '#EF4444',
            sub: '#F59E0B',
            pointOptions: ['#EF4444', '#F59E0B', '#FFFFFF', '#000000', '#FBBF24', '#DC2626', '#EA580C', '#FDE68A'],
        },
        text: 'Slam it\ndown!',
        bgQuery: 'Slam Dunk (manga)',
    },
    // === More cartoon/character themes ===
    {
        id: 'anime-pokemon',
        title: 'Pokemon',
        color: {
            main: '#0a1a2f',
            point: '#FFCB05',
            sub: '#3B4CCA',
            pointOptions: ['#FFCB05', '#3B4CCA', '#FF0000', '#EE1515', '#22C55E', '#06B6D4', '#EF4444', '#F59E0B'],
        },
        text: 'Gotta catch\nthem all!',
        bgQuery: 'Pikachu',
    },
    {
        id: 'anime-naruto',
        title: 'Naruto',
        color: {
            main: '#1a1410',
            point: '#FF6B35',
            sub: '#1E90FF',
            pointOptions: ['#FF6B35', '#1E90FF', '#FFD700', '#000000', '#FF4500', '#FFA500', '#FFFFFF', '#FBBF24'],
        },
        text: 'Believe it!',
        bgQuery: 'Naruto',
    },
    {
        id: 'anime-onepiece',
        title: 'One Piece',
        color: {
            main: '#0d1b3a',
            point: '#FF0000',
            sub: '#FFD700',
            pointOptions: ['#FF0000', '#FFD700', '#003399', '#FFFFFF', '#FF6B35', '#FFA500', '#FFD23F', '#FFFFFF'],
        },
        text: 'I\'ll be\nKing!',
        bgQuery: 'Monkey D. Luffy',
    },
    {
        id: 'anime-demonslayer',
        title: 'Demon Slayer',
        color: {
            main: '#0a0a14',
            point: '#22C55E',
            sub: '#000000',
            pointOptions: ['#22C55E', '#000000', '#FF0000', '#F59E0B', '#FFFFFF', '#DC2626', '#10B981', '#FBBF24'],
        },
        text: 'Slay\nthem all!',
        bgQuery: 'Tanjiro Kamado',
    },
    {
        id: 'anime-mha',
        title: 'My Hero Academia',
        color: {
            main: '#0d1f1f',
            point: '#22C55E',
            sub: '#EF4444',
            pointOptions: ['#22C55E', '#EF4444', '#FFFFFF', '#000000', '#FBBF24', '#3B82F6', '#10B981', '#DC2626'],
        },
        text: 'Plus\nUltra!',
        bgQuery: 'My Hero Academia',
    },
    {
        id: 'anime-doraemon',
        title: 'Doraemon',
        color: {
            main: '#0a1428',
            point: '#00A0E9',
            sub: '#FFD700',
            pointOptions: ['#00A0E9', '#FFD700', '#FF0000', '#22C55E', '#FFFFFF', '#FF6B35', '#FFCB05', '#06B6D4'],
        },
        text: 'Any gadget\nyou wish!',
        bgQuery: 'Doraemon',
    },
    {
        id: 'anime-shinchan',
        title: 'Shin Chan',
        color: {
            main: '#1a1a2e',
            point: '#FF6B6B',
            sub: '#FFD700',
            pointOptions: ['#FF6B6B', '#FFD700', '#FF0000', '#FFFFFF', '#06B6D4', '#EF4444', '#FBBF24', '#F59E0B'],
        },
        text: 'Action\nKamen!',
        bgQuery: 'Crayon Shin-chan',
    },
    {
        id: 'anime-jujutsu',
        title: 'Jujutsu Kaisen',
        color: {
            main: '#0a0a0f',
            point: '#3B82F6',
            sub: '#000000',
            pointOptions: ['#3B82F6', '#000000', '#FFFFFF', '#EF4444', '#A855F7', '#FF0000', '#06B6D4', '#FBBF24'],
        },
        text: 'Cursed\nenergy!',
        bgQuery: 'Satoru Gojo',
    },
    {
        id: 'anime-spyfamily',
        title: 'Spy x Family',
        color: {
            main: '#1a0a28',
            point: '#EC4899',
            sub: '#FFD700',
            pointOptions: ['#EC4899', '#FFD700', '#3B82F6', '#000000', '#FFFFFF', '#A855F7', '#F472B6', '#FBBF24'],
        },
        text: 'Mission\nstart!',
        bgQuery: 'Anya Forger',
    },
    {
        id: 'anime-haikyuu',
        title: 'Haikyuu',
        color: {
            main: '#0a0f1f',
            point: '#FF6B35',
            sub: '#000000',
            pointOptions: ['#FF6B35', '#000000', '#FFD700', '#3B82F6', '#FFFFFF', '#22C55E', '#FBBF24', '#EF4444'],
        },
        text: 'Fly\nhigh!',
        bgQuery: 'Haikyu',
    },
    {
        id: 'anime-cars',
        title: 'Cars (Lightning)',
        color: {
            main: '#0a0a0a',
            point: '#EF4444',
            sub: '#FFD700',
            pointOptions: ['#EF4444', '#FFD700', '#000000', '#FFFFFF', '#DC2626', '#FFA500', '#FBBF24', '#FDE68A'],
        },
        text: 'Ka-chow!',
        bgQuery: 'Lightning McQueen',
    },
    {
        id: 'anime-marvel-spiderman',
        title: 'Spider-Man',
        color: {
            main: '#0a0a14',
            point: '#EF4444',
            sub: '#3B82F6',
            pointOptions: ['#EF4444', '#3B82F6', '#000000', '#FFFFFF', '#DC2626', '#1E40AF', '#000080', '#FBBF24'],
        },
        text: 'With great\npower!',
        bgQuery: 'Spider-Man',
    },
];
